import { CollapsibleSection } from "components/collapsibleSection"
import { IOrderDetail } from "interfaces"


export const BuyerSection = ({orderDetailData} : {orderDetailData: IOrderDetail | null}) => {
  return (
    <CollapsibleSection 
      label="Buyer Information"
      defaultOpen={true}
    >
      <div className="grid gap-x-4 gap-y-6 px-4 py-4 text-sm sm:px-6 grid-cols-12 lg:gap-x-6" style={{wordBreak: "break-word"}}>
        <div className="col-span-4 sm:col-span-2">
          <p className="font-medium">
            Customer Code
          </p>
        </div>
        <div className="col-span-8 sm:col-span-10">
          <p>
            {orderDetailData?.buyer.customer_code}
          </p>
        </div>
        <div className="col-span-4 sm:col-span-2">
          <p className="font-medium">
            Full Name
          </p>
        </div>
        <div className="col-span-8 sm:col-span-10">
          <p>
            {orderDetailData?.buyer.name}
          </p>
        </div>
        <div className="col-span-4 sm:col-span-2">
          <p className="font-medium">
            Email
          </p>
        </div>
        <div className="col-span-8 sm:col-span-10">
          <p>
            {orderDetailData?.buyer.email} {orderDetailData?.is_sent_email_success ? <span className="text-green-600">(Email payment successful has been sent)</span> : <></>}
          </p>
        </div>
        <div className="col-span-4 sm:col-span-2">
          <p className="font-medium">
            Phone
          </p>
        </div>
        <div className="col-span-8 sm:col-span-10">
          <p>
            {orderDetailData?.buyer.phone ? `(+${orderDetailData?.buyer.phone_area_code}) ${orderDetailData?.buyer.phone}` : ""}
          </p>
        </div>
      </div>
    </CollapsibleSection>
  )
}